import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { DialogModule } from '@components/dialog/dialog.module';
import { LoaderComponentModule } from '@components/loader/loader.module';
import { ModalComponentModule } from '@components/modal/modal.module';
import { TabsComponentModule } from '@components/tabs/tabs.module';
import { CoreModule } from '@core/core.module';
import { ElementsModule } from '@shared/elements/elements.module';
import { DialogBillingDetailsComponent } from './dialog/billing-details/billing-details.component';
import { PlaidLinkModule } from '@components/plaid-link/plaid-link.module';
import { TranslateModule } from '@ngx-translate/core';
import { FormValidationModule } from '@components/form-validation/form-validation.module';
import { DialogPaymentMethodComponent } from './dialog/payment-method/payment-method.component';
import { DialogSubscribeComponent } from './dialog/subscribe/subscribe.component';
import { MediaComponentModule } from '@components/media/media.module';

@NgModule({
    imports: [
        CoreModule.forChild(),
        CommonModule,
        ElementsModule,
        DialogModule,
        ReactiveFormsModule,
        TabsComponentModule,
        ModalComponentModule,
        LoaderComponentModule,
        PlaidLinkModule,
        TranslateModule,
        FormValidationModule,
        MediaComponentModule
    ],
    declarations: [
        DialogSubscribeComponent,
        DialogPaymentMethodComponent,
        DialogBillingDetailsComponent,
    ],
    providers: [],
})
export class BillingSharedModule {}